export enum NotificationStatus {
  Pending = 0,
  Succeed = 1,
  Failed = 2,
  NothingToDo = 3,
}
